<div class="flex-row-split height100p">
    <p-panel class="flex-item-fixed width500 full-height" header="Optionen">
        <sm-form  [form]="form">
        </sm-form>
        <p-splitButton icon="fas fa-tower-broadcast" label="Verbindung laden ..." [model]="connectionItems" (onClick)="loadConnection()" (onDropdownClick)="updateConnectionItems()"></p-splitButton>
        <app-config-editor-tree #configEditorTree [def]="def" [showInfoColumn]="false" [propColumnWidth]="'250px'">
        </app-config-editor-tree>
        <p-button icon="fas fa-plug" label="Verbindung testen" (onClick)="checkConnection()"></p-button>
    </p-panel>
    <textarea pInputTextarea spellcheck=false class="flex-item-fill height100p monospace no-resize" [ngModel]="result"></textarea>
</div>
